const REQUIRED_CONFIG_KEYS = ['BFF_URL', 'BACK_URL', 'KEYCLOAK_URL', 'KEYCLOAK_REALM', 'KEYCLOAK_CLIENT_ID']

function normalizeConfig(rawConfig = {}) {
  return Object.fromEntries(
    Object.entries(rawConfig).map(([key, value]) => [
      key,
      typeof value === 'string' ? value.trim() : value
    ])
  )
}

const runtimeConfig = normalizeConfig(window.__config || {})

export function getRuntimeConfig() {
  return runtimeConfig
}

export function getConfigValue(key, fallback = null) {
  const value = runtimeConfig[key]
  if (value === undefined || value === null || value === '') {
    return fallback
  }
  return value
}

export function validateRuntimeConfig(log = console) {
  const missing = REQUIRED_CONFIG_KEYS.filter((key) => !getConfigValue(key))

  if (missing.length > 0) {
    log.error('[Config] Missing runtime config keys:', missing.join(', '))
  }

  return {
    valid: missing.length === 0,
    missing
  }
}
